import React from "react";
import styled from "styled-components";

/**
 * 公開静的ページ（お問い合わせ / 利用規約 / プライバシーポリシー等）共通の
 * ページ冒頭タイトル。英語タイトル + 日本語サブタイトルの 2 段構成。
 */
export interface PageHeroProps {
  /** 主タイトル（例: "Privacy Policy"） */
  title: React.ReactNode;
  /** 補助タイトル（例: "プライバシーポリシー"）。省略可 */
  subtitle?: React.ReactNode;
}

const HeroSection = styled.section.attrs({
  className: "u-w100 u-col-center u-text-center",
})`
  padding: 80px 24px 48px;
  background-color: var(--soremo-background);

  @media (min-width: 768px) {
    padding: 120px 48px 64px;
  }
`;

const HeroTitle = styled.h1.attrs({
  className: "heading-spacing-2140 u-mb16",
})`
  color: #000;
`;

const HeroSubtitle = styled.p.attrs({
  className: "bodytext-13 u-text-light-gray",
})`
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;

const PageHero: React.FC<PageHeroProps> = ({ title, subtitle }) => {
  return (
    <HeroSection>
      <HeroTitle>{title}</HeroTitle>
      {subtitle ? <HeroSubtitle>{subtitle}</HeroSubtitle> : null}
    </HeroSection>
  );
};

export default PageHero;
